import styles from './bancocad.module.css';
import ui from "../../styles/ui.module.css";
import React, { useState, useEffect, useRef } from "react";
import api, { baseURL } from "../../services/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from '../../components/Spinner/carregando';
import { FiTrash2, FiEdit } from "react-icons/fi";
import useConfirmDialog from "../../components/ConfirmModal/useConfirmDialog.jsx";


const envUrl = (baseURL || '').trim();
const apiBase = envUrl || '/api';

const Bancocad = () => {
  const [isLoading, setIsLoading] = useState(false);
  const bancoRef = useRef(null);
  const [formData, setFormData] = useState({
    nomeBanco: "",
    numeroConta: "",
    moeda: "USD",
    iconeBanco: null,
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [bancos, setBancos] = useState([]);
  const { confirm, ConfirmModal } = useConfirmDialog({
    confirmClassName: `${ui.butdesktop} ${ui.btnPrimary}`,
    cancelClassName: ui.butdesktop,
  });

  useEffect(() => {
    const carregarBancos = async () => {
      try {
        const resposta = await api.get("/bancos");
        //console.log("ln 26, Dados recebido do banco:", resposta.data);
        setBancos(resposta.data);
      } catch (erro) {
        console.error("Erro ao carregar BANCOS", erro);
        toast.error("Erro ao carregar BANCOS.");
      }
    };
    carregarBancos();
    toast.success("Bancos carregados com sucesso");
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFormData((prevData) => ({
      ...prevData,
      iconeBanco: file,
    }));
    const reader = new FileReader();
    reader.onload = () => setPreviewImage(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nomeBanco || !formData.numeroConta || !formData.moeda) {
      toast.warn("Por favor, preencha todos os campos.");
      return;
    }

    try {
      setIsLoading(true)
      const formDataUpload = new FormData();
      formDataUpload.append("nomeBanco", formData.nomeBanco);
      formDataUpload.append("numeroConta", formData.numeroConta);
      formDataUpload.append("moeda", formData.moeda);
      if (formData.iconeBanco && typeof formData.iconeBanco !== "string") {
        formDataUpload.append("iconeBanco", formData.iconeBanco);
      }

      //console.log("🟢 Dados antes do envio:", Object.fromEntries(formDataUpload));

      let response;
      if (formData.ID_BANCO) {
        //console.log("Chamando o endpoint Update BANCO para ID:", formData.ID_BANCO);
        response = await api.put(`/bancos/${formData.ID_BANCO}`, formDataUpload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Banco atualizado com sucesso");
      } else {
        //console.log("Chamou o endpoint adicionar BANCO!");
        response = await api.post("/bancos", formDataUpload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      const resposta = await api.get("/bancos");
      setBancos(resposta.data);

      setFormData({
        ID_BANCO: "",
        nomeBanco: "",
        numeroConta: "",
        moeda: "USD",
        iconeBanco: null,
      });
      setPreviewImage(null);
    } catch (erro) {
      console.error("Erro ao salvar Banco:", erro);
      toast.error("Erro ao salvar Banco.");
    } finally{
      setIsLoading(false);
    }
  };

  const handleEdit = (index) => {
    const bancoParaEditar = bancos[index];
    console.log("Banco selecionado para edição:", bancoParaEditar);
    setFormData({
      ID_BANCO: bancoParaEditar?.ID_BANCO || bancoParaEditar?.ID || "",
      nomeBanco: bancoParaEditar?.NOME || "",
      numeroConta: bancoParaEditar?.CONTA || "",
      moeda: bancoParaEditar?.MOEDA || "USD",
      iconeBanco: bancoParaEditar?.LOGO_PATH || "",
    });
  };

  const handleDelete = async (index) => {
    const confirmar = await confirm("Tem certeza que deseja deletar este Banco?");
    if (!confirmar) return;

    try {
      setIsLoading(true);
      const bancoParaDeletar = bancos[index];
      await api.delete(`/bancos/${bancoParaDeletar.ID_BANCO || bancoParaDeletar.ID}`);
      toast.success("Banco deletado com sucesso!");

      const resposta = await api.get("/bancos");
      setBancos(resposta.data);
    } catch (erro) {
      toast.error("Erro ao deletar Banco.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className={`${styles.root} ${styles['bancocad-formulario-com-lista']}`}>
      <ConfirmModal />
      <form onSubmit={handleSubmit} className={styles['bancocad-formulario']}>
        <h2 className={`${ui.titg}`}>{formData.ID_BANCO ? "Editar Banco" : "Cadastrar Banco"}</h2>
        <div>
          <label className={`${ui.labdesktop}`}>Nome do Banco</label>
          <input
            className={`${ui.inpdesktop}`}
            type="text"
            name="nomeBanco"
            value={formData.nomeBanco}
            onChange={handleChange}
            placeholder="Ex.: Banco do Brasil"
            ref={bancoRef}
            required
          />
        </div>
        <div>
          <label className={`${ui.labdesktop}`}>Número da Conta</label>
          <input
            className={`${ui.inpdesktop}`}
            type="text"
            name="numeroConta"
            value={formData.numeroConta}
            onChange={handleChange}
            placeholder="Ex.: 12345678"
            required
          />
        </div>
        <div>
          <label className={`${ui.labdesktop}`}>Moeda</label>
          <select
            className={`${ui.seldesktop}`}
            name="moeda"
            value={formData.moeda}
            onChange={handleChange}
          >
            <option value="USD">USD</option>
            <option value="BRL">BRL</option>
            <option value="BOB">BOB</option>
          </select>
        </div>
        <div>
          <label className={`${ui.labdesktop}`}>Ícone do Banco</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
          {previewImage && (
            <div className='previsimg'>
              <img
                src={previewImage}
                alt="Ícone do Banco"
              />
              <p>Pré-visualização</p>
            </div>
          )}
        </div>
        <button type="submit" className={`${ui.butdesktop}`}>{formData.ID_BANCO ? "Atualizar" : "Salvar"}</button>
      </form>

      <div className={styles['bancocad-lista-bancos']}>
        <h2 className={`${ui.titg}`}>Bancos Cadastrados</h2>
        {bancos.length > 0 ? (
            <ul>
            {bancos.map((banco, index) => (
              <li key={index} className={styles['bancocad-banco-item']}>
                <div>
                  <img
                    src={
                        banco?.LOGO_PATH
                          ? `${apiBase}/logoBanco/${banco.LOGO_PATH.split('/').pop()}`
                          : `${apiBase}/logoBanco/123.jpg` // URL de uma imagem padrão
                      }

                    //src={`${apiBase}/logoBanco/${banco.LOGO_PATH.split('/').pop()}`}
                    alt={banco.NOME}
                    style={{ width: "20px", height: "20px", margin: "0px 10px" }}
                  />
                  <p>{banco.NOME}</p>
                  <p>{banco.CONTA}</p>
                </div>
                <div className={`${ui.buteditarremover}`}>
                  <button
                    className={`${ui.buteditar}`}
                    onClick={() => handleEdit(index)}
                    
                  >
                    <FiEdit size={15} />
                  </button>
                  <button
                    className={`${ui.butremover}`}
                    onClick={() => handleDelete(index)}
                    
                  >
                    <FiTrash2 size={15} />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>Nenhum banco cadastrado ainda.</p>
        )}
      </div>

      <ToastContainer limit={1} position="top-right" autoClose={3000} />
      <Spinner
        isLoading={isLoading}
      />
    </main>
  );
};

export default Bancocad;
